<script lang="ts">
    import {email, fetchOrigin, page} from "../data.ts";
    import {onMount} from "svelte";
    import {busy} from "../busy.ts";
    import {sleep} from "@shared/Utils.ts";

    let msg = '';
    let submitting = false;

    async function verifyCode() {
        submitting = true;
        code = code?.trim();
        if (!code || code.length !== 6) {
            msg = 'Code must be 6 digits';
            submitting = false;
            return;
        }
        msg = '';
        if (!$email) {
            msg = 'Email not set';
            submitting = false;
            return;
        }
        const result = await fetchOrigin(`/verify-code?${new URLSearchParams({email: $email, code}).toString()}`);
        const json = await result.json();
        if (json.success) {
            page.set('Registration')
        } else {
            await sleep(1000);
            msg = json.error;
        }
        submitting = false;
    }

    let code;

    $: if (code && code.length >= 6) {
        verifyCode();
    }

    onMount(() => {
        if ($email === '') {
            console.log('email aint right')
            page.set('EnterEmail')
        }
    })
</script>

<article style="max-width: 720px; margin: 2rem auto;">
    <h1>Enter the code sent to {$email}</h1>
    <p>
        Code will arrive from noreply@wobregistration.org.
    </p>
    <button><small on:click={() => page.set('EnterEmail')}>change email or send code again</small></button>

    <label>
        Code
        <input type="text" name="code" placeholder="xxxxxx" required bind:value={code} on:keydown={(e) => e.key === 'Enter' && verifyCode()}/>
    </label>


    {#if msg}
        <div class="alert alert-warning">
            {msg}
        </div>
    {/if}

    <button use:busy={verifyCode} aria-busy={submitting}>Submit</button>
</article>